<template>

  <select-org
    :label="label"
    type="Telco"
    v-model="formData"
    :required="required"
    :placeholder="placeholder"
    :help-text="helpText"
    :size="size"
    :disabled="disabled"
    :full-object="fullObject"
    :no-form="noForm"
    :limit="localLimits"
    @change="updated"
    />

</template>

<script>

import SelectOrg from '@/components/atoms/selects/SelectOrg'

export default {
  name: 'select-sharer',

  components: {
    SelectOrg
  },

  props: {

    label: {
      type: String,
      default: 'Sharer'
    },

    value: {
//      type: String,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: 'default'
    },

    limit: {
      type: Array,
      default: null
    },

    placeholder: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },


  watch: {

    limit: function (lim) {
      this.localLimits = lim
    }

  },


  data () {
    return {
      formData: this.value,
      localLimits: this.limit
    }
  },

}
</script>
